import { render } from "./TagCardSkeleton.vue?vue&type=template&id=2211032a&scoped=true"
const script = {}

import "./TagCardSkeleton.vue?vue&type=style&index=0&id=2211032a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2211032a"]])

export default __exports__